import { MerchantPermissions } from '@/rbac'
import KYCStatus from '@/enums/modules/setup/KYCStatus'
import { getDaysUntilDeadline } from '@/utils/common'

export default {
  data () {
    return {
      hasCreateWROPerm: false,
      isKYCApproved: false,
      unsubscribeKYC: null,
      inquiryId: null,
      currentKYCStatus: null,
      currentKYCSession: null,
      completionKYCDeadline: null,
      inquiryTypeId: null,
      daysUntilKYCDeadline: null,
      isActionsBlockedByKYC: false,
      impersonatedUser: null,
      isUserAdmin: false,
      kycAttempts: null
    }
  },
  async mounted () {
    // initial value
    const kyc = await this.$shipBobStore.getters['user/getUserOrgKYC']
    const user = await this.$shipBobStore.getters['user/getUser']
    this.isUserAdmin = user?.isAdmin
    this.impersonatedUser = user?.impersonatedUserId

    this.updateValues(kyc)

    // watch for changes
    this.unsubscribeKYC = this.$shipBobStore.watch(
      (state, getters) => getters['user/getUserOrgKYC'],
      (newValue) => {
        this.updateValues(newValue)
      }
    )
  },
  methods: {
    updateValues (kyc) {
      const daysUntilKYCDeadline = kyc?.completionKYCDeadline ? getDaysUntilDeadline(kyc?.completionKYCDeadline) : null
      const isKYCFailed = [KYCStatus.Expired, KYCStatus.Failed, KYCStatus.Declined].includes(kyc?.currentKYCStatus)

      this.inquiryId = kyc?.inquiryId
      this.currentKYCStatus = kyc?.currentKYCStatus
      this.currentKYCSession = kyc?.currentKYCSession
      this.completionKYCDeadline = kyc?.completionKYCDeadline
      this.inquiryTypeId = kyc?.inquiryTypeId
      this.kycAttempts = kyc?.attempts
      this.isKYCApproved = (kyc === null || this.isUserAdmin) ? true : kyc?.currentKYCStatus === KYCStatus.Approved
      this.hasCreateWROPerm = this.isUserAdmin ? true : MerchantPermissions.can('manage', 'wro_create')
      this.isActionsBlockedByKYC = !this.isKYCApproved && (isKYCFailed || (daysUntilKYCDeadline !== null && daysUntilKYCDeadline <= 0))
      this.$shipBobStore.dispatch('user/setIsActionsBlockedByKYC', this.isActionsBlockedByKYC)
    },
    triggerKYCStatusCTA () {
      this.$shipBobStore.dispatch('user/triggerKYCAction')
    }
  },
  beforeDestroy () {
    if (this.unsubscribeKYC) {
      this.unsubscribeKYC()
    }
  }
}
